(function() {
  vtex.define('shipping/script/mixin/withi18n',[], function() {
    var localesLoaded;
    localesLoaded = {};
    return function() {
      var localePath;
      localePath = null;
      this.defaultAttrs({
        locale: 'pt-BR'
      });
      this.extendTranslations = function(translation) {
        if (window.vtex.i18n[this.attr.locale]) {
          window.vtex.i18n[this.attr.locale] = _.extend(translation, window.vtex.i18n[this.attr.locale]);
          i18n.addResourceBundle(this.attr.locale, 'translation', window.vtex.i18n[this.attr.locale]);
        } else {
          i18n.addResourceBundle(this.attr.locale, 'translation', translation);
        }
        window.ParsleyConfig = window.ParsleyConfig || {};
        window.ParsleyConfig.i18n = window.ParsleyConfig.i18n || {};
        window.ParsleyConfig.i18n[this.attr.locale] = $.extend(window.ParsleyConfig.i18n[this.attr.locale] || {}, i18n.t('validation', {
          returnObjectTrees: true
        }));
        if (window.ParsleyValidator != null) {
          window.ParsleyValidator.addCatalog(this.attr.locale, window.ParsleyConfig.i18n[this.attr.locale], true);
          window.ParsleyValidator.setLocale(this.attr.locale);
        }
        return translation;
      };
      this.fixLocale = function(locale) {
        if (locale.match('es-')) {
          return 'es';
        } else if (locale.match('en-')) {
          return 'en';
        } else if (locale.match('fr-')) {
          return 'fr';
        } else if (locale.match('ca-')) {
          return 'ca';
        } else {
          return locale;
        }
      };
      this.setLocale = function(locale) {
        if (locale == null) {
          locale = "pt-BR";
        }
        return this.attr.locale = this.fixLocale(locale);
      };
      this.localeSelected = function(ev, locale) {
        this.setLocale(locale);
        return this.$node.i18n();
      };
      this.setLocalePath = function(path) {
        return localePath = path;
      };
      this.requireLocale = function() {
        var _this = this;
        this.attr.locale = this.fixLocale(this.attr.locale);
        return vtex.curl([localePath + this.attr.locale], function(translation) {
          if (!localesLoaded[localePath + _this.attr.locale]) {
            _this.extendTranslations(translation);
          }
          return localesLoaded[localePath + _this.attr.locale] = true;
        });
      };
      return this.after('initialize', function() {
        var locale, _ref, _ref1, _ref2;
        if (!localePath) {
          throw new Error("withi18n clients must initialize localePath by calling @setLocalePath()");
        }
        this.on(window, 'localeSelected.vtex', this.localeSelected);
        if (locale = typeof vtexjs !== "undefined" && vtexjs !== null ? (_ref = vtexjs.checkout) != null ? (_ref1 = _ref.orderForm) != null ? (_ref2 = _ref1.clientPreferencesData) != null ? _ref2.locale : void 0 : void 0 : void 0 : void 0) {
          this.localeSelected(null, locale);
        }
        if (typeof this.render === 'function') {
          return this.around('render', function(originalRender) {
            return this.requireLocale().then(originalRender);
          });
        }
      });
    };
  });

}).call(this);

